import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { take, takeUntil } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { StatsMosService } from '@shared/services/stats-mos.service';
import { Subject } from 'rxjs';
import { TakeUntilDestroy } from '@utils/auto-unsubscribe';
import { DownloadCatalogService } from '../../../../../services/download-catalog.service';

@Component({
  selector: 'app-registry-export-modal',
  templateUrl: './registry-export-modal.component.html',
  styleUrls: ['./registry-export-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@TakeUntilDestroy
export class RegistryExportModalComponent {
  public icons = CustomIcons;
  public componentDestroy: () => Subject<any>;
  @Output() public readonly menuClose = new EventEmitter<boolean>();
  constructor(private downloadCatalogService: DownloadCatalogService, private statsMosService: StatsMosService) {}

  private download(content: ArrayBuffer, type: string): void {
    const file = new Blob([content], { type: `application/${type}` });
    saveAs(file, `register.${type}`);
  }

  /*  public close(): void {
    this.dialogRef.close();
  } */

  public export(type: 'csv' | 'json'): void {
    let fileType;
    if (type === 'csv') {
      fileType = 'CSV';
    } else if (type === 'json') {
      fileType = 'JSON';
    }
    this.statsMosService
      .fireEvent({ action: 'listdownload', fileType: fileType })
      .pipe(takeUntil(this.componentDestroy()))
      .subscribe({
        error: err => {
          if (err.status !== 200) {
            throw err;
          }
        }
      });
    this.downloadCatalogService
      .downloadRegistry(type)
      .pipe(take(1))
      .subscribe((file: ArrayBuffer) => {
        this.download(file, type);
        this.menuClose.emit(true);
      });
  }
}
